import { useParams, Link, useHistory } from "react-router-dom";
import { useState } from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";
import products from "../services/products";

function ProductDetails() {
  const { id } = useParams();
  const history = useHistory();

  const [message, setMessage] = useState("");
  const [sendingMessage, setSendingMessage] = useState(false);

  const savedListings =
    JSON.parse(localStorage.getItem("buySellListings")) || [];

  const approvedSavedListings = savedListings.filter(
    (listing) => listing.status === "approved"
  );

  const savedProduct = approvedSavedListings.find(
    (item) => String(item.id) === String(id)
  );

  const defaultProduct = products.find(
    (item) => String(item.id) === String(id)
  );

  const product = savedProduct || defaultProduct;

  if (!product) {
    return (
      <>
        <Header />

        <main className="container">
          <h1>Հայտարարությունը չի գտնվել</h1>

          <Link to="/products">
            ← Վերադառնալ հայտարարություններին
          </Link>
        </main>

        <Footer />
      </>
    );
  }

  const token = localStorage.getItem("token");

  let currentUserId = null;

  if (token) {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      currentUserId = payload.id;
    } catch (error) {
      console.error("Token-ի ընթերցման սխալ", error);
    }
  }

  const isOwner =
    product.userId &&
    currentUserId &&
    String(product.userId).trim() === String(currentUserId).trim();

  console.log("PRODUCT USER ID:", product.userId);
  console.log("CURRENT USER ID:", currentUserId);
  console.log("IS OWNER:", isOwner);

  // =========================
  // SEND MESSAGE
  // =========================

  const handleSendMessage = async () => {
    if (!token) {
      alert("Հաղորդագրություն ուղարկելու համար նախ մուտք գործեք։");
      history.push("/login");
      return;
    }

    if (!product.userId) {
      alert("Այս հայտարարության վաճառողի տվյալները հասանելի չեն։");
      return;
    }

    if (isOwner) {
      alert("Դուք չեք կարող հաղորդագրություն ուղարկել ինքներդ ձեզ։");
      return;
    }

    if (!message.trim()) {
      alert("Գրեք հաղորդագրություն։");
      return;
    }

    try {
      setSendingMessage(true);

      const response = await fetch(
        "/api/messages",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify({
            receiver: product.userId,
            text: message.trim(),
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Չհաջողվեց ուղարկել հաղորդագրությունը"
        );
      }

      setMessage("");

      alert("Հաղորդագրությունը հաջողությամբ ուղարկվեց 💬");

      history.push(`/messages/${product.userId}`);
    } catch (error) {
      console.error("MESSAGE SEND ERROR:", error);

      alert(error.message);
    } finally {
      setSendingMessage(false);
    }
  };

  // =========================
  // DELETE LISTING
  // =========================

  const handleDelete = () => {
    if (!isOwner) {
      alert("Դուք չեք կարող հեռացնել ուրիշի հայտարարությունը։");
      return;
    }

    const confirmed = window.confirm(
      "Վստա՞հ եք, որ ցանկանում եք հեռացնել այս հայտարարությունը։"
    );

    if (!confirmed) {
      return;
    }

    const updatedListings = savedListings.filter(
      (item) => item.id !== product.id
    );

    localStorage.setItem(
      "buySellListings",
      JSON.stringify(updatedListings)
    );

    alert("Հայտարարությունը հեռացվեց");

    window.location.href = "/products";
  };

  // =========================
  // PAGE
  // =========================

  return (
    <>
      <Header />

      <main className="product-details">

        <div className="container product-details-inner">

          {/* PRODUCT IMAGE */}

          <div className="product-details-image">

            <img
              src={product.image}
              alt={product.name}
            />

          </div>


          {/* PRODUCT INFO */}

          <div className="product-details-info">

            <span className="product-category">
              {product.category}
            </span>

            <h1>{product.name}</h1>

            <h2>{product.price}</h2>

            <p>{product.description}</p>


            {/* SELLER CONTACT */}

            <div className="seller-contact">

              <button
                className="contact-seller"
                onClick={() => {
                  const phoneElement =
                    document.getElementById("seller-phone");

                  phoneElement.style.display = "block";
                }}
              >
                📞 Ցույց տալ հեռախոսահամարը
              </button>


              <div
                id="seller-phone"
                className="seller-phone-box"
                style={{ display: "none" }}
              >

                <strong>
                  Հեռախոսահամար
                </strong>

                <a href={`tel:${product.phone}`}>
                  {product.phone}
                </a>

              </div>

            </div>


            {/* MESSAGE SELLER */}

            {!isOwner && (
  <div className="message-seller-box">
    <Link
      to={`/messages/${product.userId}`}
      className="send-message-button"
    >
      💬 Գրել վաճառողին
    </Link>
  </div>
)}


            {/* DELETE */}

            {isOwner && (

              <button
                className="delete-listing"
                onClick={handleDelete}
              >
                🗑 Հեռացնել հայտարարությունը
              </button>

            )}


            {/* BACK */}

            <Link
              to={`/products?category=${encodeURIComponent(
                product.category
              )}`}
              className="back-products"
            >
              ← Վերադառնալ {product.category}
            </Link>

          </div>

        </div>

      </main>

      <Footer />
    </>
  );
}

export default ProductDetails;